@if (form$ | async; as form) {
  <div class="mt-1">
    <app-alerts />
  </div>

  <app-admin-box-sale-details-form
    (submitClickEvent)="handleSubmitClickEvent($event)"
    [data]="form"
    [uploadFn]="uploadFn" />
} @else {
  <app-spinner-filled />
}
